import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams, serialize } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  /* eslint-disable prettier/prettier */
  return {
    //  Generic
    getRecipientEventsOpenings: (
      idList,
      idRecipient,
      pagesize,
      pagenumber,
      orderby,
      orderdescending,
    ) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/events/openings?${encodeParams(
        {
          pagesize,
          pagenumber,
          orderby,
          orderdescending,
        },
      )}`,

    getRecipientDailyCounters: (
      idList,
      idRecipient,
      from,
      to,
      timezone,
      types,
    ) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/dailycounters?${encodeParams({ from, to, timezone })}${serialize(types, 'types', '&')}`,

    getRecipientMessagesTotalCounters: (
      idList,
      idRecipient,
      pagesize,
      pagenumber,
      orderby,
      orderdescending,
      types,
    ) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/messages/totalcounters?${encodeParams({ pagesize, pagenumber, orderby, orderdescending })}${serialize(types, 'types', '&')}`,

    getRecipientEventsClicks: (
      idList,
      idRecipient,
      pagesize,
      pagenumber,
      orderby,
      orderdescending,
    ) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/events/clicks?${encodeParams({ pagesize, pagenumber, orderby, orderdescending })}`,

    getRecipientEventsBounces: (
      idList,
      idRecipient,
      pagesize,
      pagenumber,
      orderby,
      orderdescending,
    ) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/events/bounces?${encodeParams({ pagesize, pagenumber, orderby, orderdescending })}`,

    deleteRecipientEventsBounces: (idList, idRecipient) =>
      `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/recipients/${encodeURIComponent(idRecipient)}/events/bounces`,
  }
  /* eslint-enable prettier/prettier */
})(process.env.STATS_URL)

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {number} pagesize
 * @param {number} pagenumber
 * @param {string} orderBy
 * @param {boolean} orderdescending
 */
export const getRecipientEventsOpenings = (
  idList,
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) => {
  const url = endpoints.getRecipientEventsOpenings(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )
  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {string} from
 * @param {string} to
 * @param {string} timezone
 * @param {Array[string]} types
 */
export const getRecipientDailyCounters = (
  idList,
  idRecipient,
  from,
  to,
  timezone,
  types,
) => {
  const url = endpoints.getRecipientDailyCounters(
    idList,
    idRecipient,
    from,
    to,
    timezone,
    types,
  )
  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {number} pagesize
 * @param {number} pagenumber
 * @param {string} orderBy
 * @param {boolean} orderdescending
 * @param {Array[string]} types
 */
export const getRecipientMessagesTotalCounters = (
  idList,
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
  types,
) => {
  const url = endpoints.getRecipientMessagesTotalCounters(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
    types,
  )
  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {number} pagesize
 * @param {number} pagenumber
 * @param {string} orderBy
 * @param {boolean} orderdescending
 */
export const getRecipientEventsClicks = (
  idList,
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) => {
  const url = endpoints.getRecipientEventsClicks(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )
  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {number} pagesize
 * @param {number} pagenumber
 * @param {string} orderBy
 * @param {boolean} orderdescending
 */
export const getRecipientEventsBounces = (
  idList,
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) => {
  const url = endpoints.getRecipientEventsBounces(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )
  return apiWrapper({
    method: 'get',
    url: url,
  }).then(({ data }) => data)
}

/**
 * @param {number} idList
 * @param {number} idRecipient
 * @param {array} bouncesList
 */
export const deleteRecipientEventsBounces = (
  idList,
  idRecipient,
  bouncesList,
) => {
  const url = endpoints.deleteRecipientEventsBounces(
    idList,
    idRecipient,
    bouncesList,
  )
  return apiWrapper({
    method: 'delete',
    url: url,
    data: JSON.stringify(bouncesList),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}
